'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Logo } from '@/components/CreditOne/Logo';
export interface CalculatorProps {
  amount: number;
}
export function Calculator(t0) {
  const $ = _c(9);
  const {
    amount
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      mt: "4rem",
      gap: "1rem"
    };
    t2 = <Typography variant="h6" component="div" gutterBottom={true}>Calculate your loan estimate with</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = `https://www.creditone.co.nz/embedded-calculator?member_company_name=country-caravans&amount=${amount}&utm_source=getaway-motorhome-sales&utm_medium=referral&utm_campaign=dealer_online_calculator`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Logo alt="CreditOne Calculator" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <Link href={t3} rel="noopener" target="_blank" title="CreditOne Calculator">{t4}</Link>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Typography variant="h6" component="div" gutterBottom={true}>or</Typography>;
    t7 = <Button color="secondary" href="https://www.creditone.co.nz/dealer-application/step-1/getaway-motorhome-sales?utm_source=getaway-motorhome-sales&utm_medium=referral&utm_campaign=dealer_application_form" rel="noopener" target="_blank" variant="contained">Apply for loan now</Button>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5) {
    t8 = <Box sx={t1}>{t2}{t5}{t6}{t7}</Box>;
    $[7] = t5;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}